<template>
  <!-- 用户管理页面 -->
  <Content class="goodsBox">
    <!-- 添加按钮，点击后显示添加用户弹窗 -->
    <Button type="primary" style="margin-bottom: 24px" @click="show">
      添加
    </Button>
    <!-- 搜索表单，用于搜索用户信息 -->
    <Form id="searchForm" :model="formItem" :label-width="80" inline>
      <!-- 账号输入框，用于输入搜索关键字 -->
      <FormItem label="账号">
        <Input v-model="formItem.key" placeholder="模糊搜索" clearable />
      </FormItem>
      <!-- 查询和重置按钮 -->
      <FormItem :label-width="20">
        <!-- 查询按钮，点击后根据输入的关键字进行搜索 -->
        <Button type="primary" @click="search">查询</Button>
        <!-- 重置按钮，点击后清空搜索关键字并重新加载列表 -->
        <Button style="margin-left: 8px" @click="clear">重置</Button>
      </FormItem>
    </Form>
    <!-- 用户列表表格，展示用户数据 -->
    <Table
      :columns="columns"
      :data="tableData"
      :height="tablesHeight"
      border
    ></Table>
    <!-- 分页组件，用于分页显示用户数据 -->
    <Page
      class="table_page_css"
      v-show="total"
      :total="total"
      :current="searchInfo.pageNo"
      :page-size="searchInfo.pageSize"
      :page-size-opts="pageSizeOpts"
      @on-change="pageNoChange"
      @on-page-size-change="pageSizeChange"
      show-sizer
      show-elevator
      show-total
    />
    <!-- 添加和更新用户信息的弹窗组件，通过ref引用在方法中调用 -->
    <AddUpdate @reload="getList" ref="AddUpdate"></AddUpdate>
    <!-- 分配角色弹窗组件，通过ref引用在方法中调用 -->
    <UsersRole @reload="getList" ref="UsersRole"></UsersRole>
  </Content>
</template>
<script>
import { usersPage, usersDel, usersUpdateState } from '@/api/user'
import AddUpdate from './UsersAddUpdate'
import UsersRole from './UsersRole'
export default {
  name: 'Users',
  components: {
    AddUpdate,
    UsersRole,
  },
  data() {
    return {
      columns: [
        {
          title: '账号',
          key: 'us',
        },
        {
          title: '性别',
          key: 'sex',
          render(h, params) {
            return h('div', params.row.sex === 0 ? '男' : '女')
          },
        },
        {
          title: '角色',
          key: 'role_name',
          render: (h, params) => {
            // 显示角色名称，如果没有则显示"未分配"
            const roleName = params.row.role_name || params.row.roleName || '未分配'
            return h('div', roleName)
          },
        },
        {
          title: '状态',
          key: 'state',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'i-switch',
                {
                  props: {
                    value: params.row.state ? true : false,
                  },
                  on: {
                    'on-change': (state) => {
                      this.updateState(params.row.id, state)
                    },
                  },
                },
                'View',
              ),
            ])
          },
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.$refs.UsersRole.init(params.row)
                    },
                  },
                },
                '分配角色',
              ),
              h(
                'Poptip',
                {
                  props: {
                    confirm: true,
                    transfer: true,
                    title: '您确认删除这条内容吗？',
                  },
                  on: {
                    'on-ok': () => {
                      this.remove(params.row._id)
                    },
                  },
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small',
                      },
                    },
                    '删除',
                  ),
                ],
              ),
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: {
        pageNo: 1,
        pageSize: 5,
      },
      pageSizeOpts: [1, 2, 5, 10],
      formItem: {
        key: '',
      },
      tablesHeight: 0,
    }
  },
  methods: {
    // 设置表格高度的方法
    setTablesHeight() {
      // 初始化变量aH为0，用于存储计算后的表格高度
      let aH = 0
      // 获取id为'app'的DOM元素
      let oA = document.getElementById('app')
      // 获取该元素的客户区高度或偏移高度
      let oH = oA.clientHeight || oA.offsetHeight
      // 获取id为'searchForm'的DOM元素
      let sA = document.getElementById('searchForm')
      // 获取该元素的客户区高度或偏移高度
      let sH = sA.clientHeight || sA.offsetHeight
      // 计算表格高度，减去搜索表单的高度和固定的265像素
      aH = oH - sH - 265
      // 将计算后的高度赋值给组件的tablesHeight属性
      this.tablesHeight = aH
    },
    // 获取用户列表的方法
    getList() {
      // 调用usersPage函数，传入searchInfo对象
      usersPage(this.searchInfo)
        .then((res) => {
          // 如果响应状态码为200，表示成功
          if (res.data.code === 200) {
            // 解构响应数据
            const data = res.data
            // 处理角色数据，确保角色名称正确显示
            if (data.data && data.data.length > 0) {
              data.data.forEach(item => {
                // 处理角色信息：后端返回的是 roles 数组，取第一个元素的 role_name/roleName
                if (item.roles && item.roles.length > 0) {
                  const roleInfo = item.roles[0]
                  const roleName = roleInfo.role_name || roleInfo.roleName
                  item.role_name = roleName || item.role_name || '未分配'
                  item.roleName = roleName || item.roleName
                } else if (item.role_name || item.roleName) {
                  item.role_name = item.role_name || item.roleName
                } else {
                  item.role_name = '未分配'
                }
              })
            }
            // 将数据赋值给组件的tableData属性
            this.tableData = data.data
            // 将总条数赋值给组件的total属性
            this.total = data.total
          } else {
            // 如果状态码不是200，显示错误消息
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          // 如果请求过程中出现错误，显示错误消息
          this.$Message.error(err)
        })
    },
    // 搜索方法
    search() {
      // 更新searchInfo对象，包含搜索关键字、页码和每页数量
      this.searchInfo = {
        key: this.formItem.key,
        pageNo: 1,
        pageSize: this.searchInfo.pageSize,
      }
      // 调用getList方法重新获取数据
      this.getList()
    },
    // 清除搜索条件的方法
    clear() {
      // 重置formItem对象
      this.formItem = {
        key: '',
      }
      // 重置searchInfo对象
      this.searchInfo = {
        pageNo: 1,
        pageSize: 5,
      }
      // 调用getList方法重新获取数据
      this.getList()
    },
    // 显示添加或更新用户信息的方法
    show(params) {
      // 调用AddUpdate组件的init方法
      this.$refs.AddUpdate.init()
    },
    // 修改账号状态的方法
    updateState(id, state) {
      // 调用usersUpdateState函数，传入id和state
      usersUpdateState({ id, state })
        .then((res) => {
          // 如果响应状态码为200，表示成功
          if (res.data.code === 200) {
            // 显示成功消息
            this.$Message.success('状态修改成功')
          } else {
            // 如果状态码不是200，显示错误消息
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          // 如果请求过程中出现错误，显示错误消息
          this.$Message.error(err)
        })
    },
    // 删除用户的方法
    remove(_id) {
      // 调用usersDel函数，传入_id
      usersDel({ _id: _id })
        .then((res) => {
          // 如果响应状态码为200，表示成功
          if (res.data.code === 200) {
            // 显示成功消息
            this.$Message.success('删除成功')
            // 重新获取列表数据
            this.getList()
          } else {
            // 如果状态码不是200，显示错误消息
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          // 如果请求过程中出现错误，显示错误消息
          this.$Message.error(err)
        })
    },
    // 页码改变时的处理方法
    pageNoChange(current) {
      // 更新searchInfo对象的pageNo属性
      this.searchInfo.pageNo = current
      // 调用getList方法重新获取数据
      this.getList()
    },
    // 每页显示数量改变时的处理方法
    pageSizeChange(val) {
      // 重置页码为1
      this.searchInfo.pageNo = 1
      // 更新searchInfo对象的pageSize属性
      this.searchInfo.pageSize = val
      // 调用getList方法重新获取数据
      this.getList()
    },
  },
  // 组件挂载后的生命周期钩子
  mounted() {
    // 调用getList方法获取用户列表数据
    this.getList()
    // 使用setTimeout延迟50毫秒后执行setTablesHeight方法
    // 这是为了确保DOM元素已经渲染完成，可以正确计算高度
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    // 为窗口添加resize事件监听器，当窗口大小改变时，重新计算表格高度
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.goodsBox {
  .ivu-form-inline .ivu-form-item {
    width: 267px;
  }
}
</style>
